import Vue from "vue";
import ServiceStatusListSelect from "../../shared/ServiceStatusListSelect";
export default Vue.extend({
  template: `
  <div style="padding:15px;">
  <service-status-list-select
                        :is-disabled="false"
                        v-model="status"
                        :allowed-status-names="allowedStatusNames"
                        @onSelect="onItemStatusSelect"
                      ></service-status-list-select>
  </div>
    `,
  components: { ServiceStatusListSelect },
  data: function () {
    return {
      status: "",
      statusName: "",
    };
  },
  computed: {
    // #11287 part 1b: a seller MP service awaiting confirmation ("Requested by MP")
    // may only be Confirmed or Rejected. MP Quotation is fully blocked earlier, at
    // cell-edit-start (onAgGridCellEditStart), so it never reaches this editor.
    allowedStatusNames() {
      const d = this.params && this.params.data;
      if (
        d &&
        d.source &&
        d.source.name === "GTWEB" &&
        d.status === "Requested by MP"
      ) {
        return ["Confirmed", "Rejected"];
      }
      return null;
    },
  },

  mounted() {},

  methods: {
    onItemStatusSelect(payload) {
      this.statusName = payload.name;
      this.params.data.statusId = payload.id;
      this.params.api.stopEditing();
    },
    getValue() {
      return this.statusName;
    },
    isPopup() {
      return true;
    },
  },
  beforeMount() {
    this.status = this.params.data.statusId;
    this.statusName = this.params.data.status;
  },
});



// WEBPACK FOOTER //
// ./src/components/gt/shared/ag-grid/AgServiceStatusEditor.js